import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, FormField, Grid, List, Select, Text, TextArea, TextInput } from "grommet";
import { debounce } from "lodash";
import * as React from "react";
import Avatar from "react-avatar";
import { useNavigate } from "react-router-dom";
import Flag from "../components/Flag";
import StyledModal from "../components/StyledModel";
import ThemeBuilder from "../components/ThemeBuilder";
import OrganizationSearch from "../organizations/OrganizationSearch";
import { Organization } from "../organizations/OrganizationStore";
import { TeamRow } from "../teams/TeamsManagement";
import { getTeams, TeamViewModel } from "../teams/TeamsStore";
import TournamentDetails from "./TournamentDetails";
import { createTournament, CreateTournamentRequest } from "./TournamentsStore";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const xmark = <FontAwesomeIcon icon={["fad", "xmark"]}></FontAwesomeIcon>;

const CreateTournament = () => {
    let [organization, setOrganization] = React.useState({} as Organization);

    let [tournament, setTournament] = React.useState(new CreateTournamentRequest());

    let [isCreating, setIsCreating] = React.useState(false);

    let [error, setError] = React.useState("");

    const navigate = useNavigate();

    let create = () => {
        setIsCreating(true);
        createTournament({ ...tournament, organizationID: organization.id }).then(
            (result) => {
                navigate(`/tournaments/${result.tournamentID}`);
            },
            (error) => {
                setError(error);
            }
        );
    };

    const onChange = (updatedTournament) => {
        setTournament({ ...tournament, ...updatedTournament });
    };

    return (
        <div>
            <h1>Create Tournament</h1>
            <Box>
                <OrganizationSearch onSelect={(organization) => setOrganization(organization)}></OrganizationSearch>
                <TournamentDetails tournament={tournament} isBusy={isCreating} onChange={onChange}></TournamentDetails>
                <Button primary onClick={create} disabled={isCreating || !tournament.name || !organization.id} label="Create"></Button>
                <Box>{error && <pre>{JSON.stringify(error, null, 2)}</pre>}</Box>
            </Box>
        </div>
    );
};

export default CreateTournament;
